<template>
  <div class="container meal-detail">
    <h1
      class="title is-size-4-mobile has-text-left-desktop"
      v-if="meal && meal.new"
    >
      {{ $t("Add new meal") }}
    </h1>
    <h1
      class="title is-size-4-mobile has-text-left-desktop"
      v-else-if="meal && meal.id"
    >
      {{ $t("Editing meal") }} - {{ meal.name }}
    </h1>
    <meal-form
      v-if="meal !== undefined"
      :meal="meal"
      :actionStatus="actionStatus"
      @create="createMeal"
      @update="updateMeal"
      @remove="removeMeal"
      @cancel="cancelDetail"
      @clearErrors="clearErrors"
    />
  </div>
</template>

<script>
import { state, actions } from "@/store"
import MealForm from "@/components/meal-form"

export default {
  name: "meal-detail",
  props: ["mealId"],
  components: {
    MealForm
  },
  data() {
    return {
      actionStatus: undefined,
      currentMealRoute: this.$router.currentRoute
    }
  },
  computed: {
    meal() {
      return this.getMealOrCreate(this.mealId)
    }
  },
  watch: {
    mealId: {
      immediate: true,
      handler(mealId) {
        this.getMealOrCreate(mealId)
      }
    }
  },
  methods: {
    getMealOrCreate(mealId) {
      if (mealId === "create") {
        return this.getNewMeal()
      } else {
        return this.getExistMeal(mealId)
      }
    },
    getExistMeal(mealId) {
      return state.project.data.meals[mealId]
    },
    getNewMeal() {
      return {
        new: true,
        allergens: [],
        badges: [],
        categories: []
      }
    },
    cancelDetail() {
      if (this.$router.currentRoute === this.currentMealRoute) {
        this.$router.back()
      }
    },
    clearErrors() {
      actions.clearErrors()
      this.actionStatus = undefined
    },
    createMeal(meal) {
      actions.clearErrors()
      this.actionStatus = "DisableBtns"
      this.displayActionProgress("Save")
      actions
        .createMeal(meal)
        .then(this.cancelDetail)
        .catch(err => {
          actions.addError("create-meal-error")(err)
          this.actionStatus = undefined
        })
    },
    updateMeal(meal) {
      actions.clearErrors()
      this.actionStatus = "DisableBtns"
      this.displayActionProgress("Save")
      actions
        .updateMeal(meal.id, meal)
        .then(this.cancelDetail)
        .catch(err => {
          actions.addError("edit-meal-error")(err)
          this.actionStatus = undefined
        })
    },
    removeMeal(mealId) {
      actions.clearErrors()
      this.cancelDetail()
      this.actionStatus = "DisableBtns"
      actions
        .removeMeal(mealId)
        .then(this.cancelDetail)
        .catch(err => {
          actions.addError("remove-meal-error")(err)
          this.actionStatus = undefined
        })
    },
    displayActionProgress(actionName) {
      setTimeout(() => {
        if (this.actionStatus) {
          this.actionStatus = actionName
        }
      }, 1000)
      setTimeout(() => {
        if (this.actionStatus) {
          this.actionStatus = "Timeout"
        }
      }, 3000)
    }
  }
}
</script>

<style lang="scss" scoped>
.meal-detail {
  max-width: 800px;
}
</style>
